export const plansPage = {
  title: "Individual plans",
  titleOld: "Shared plans",
  subtitle: "Easily view and manage all of your plans and templates.",
  tabHeaders: {
    individualPlans: "Individual plans",
    multiPatientPlans: "Multi-{{patientTerm}} plans",
    templates: "Templates",
  },
  filters: {
    sortTitle: "Sort",
    sortFilters: {
      nameAsc: "A-Z",
      nameDesc: "Z-A",
      updatedOld: "Last updated: oldest",
      updatedNew: "Last updated: newest",
      newest: "Newest",
      oldest: "Oldest",
    },
    ownerFilters: {
      title: "Owner",
      myPlans: "My plans",
      entireDispensary: "Entire dispensary",
    },
    orderStatus: {
      title: "Order status",
      ordered: "Ordered",
      notOrdered: "Not ordered",
    },
    authorFilterTitle: "Show",
    authorFilters: {
      all: "All templates",
      dispensary: "My dispensary",
      fullscript: "Made by Fullscript",
    },
    dailyPacksAuthorFilters: {
      all: "All daily packs",
      dispensary: "My daily packs",
      fullscript: "Fullscript daily packs",
    },
  },
  placeholder: {
    individualPlans: "Search by {{ patientTerm }} name or email",
    multiPatientPlans: "Search by keywords or {{ patientTerm }} name",
    templates: "Search by keywords",
  },
  actions: {
    createTemplate: "Create template",
    buildTemplate: "Build template",
    buildPlan: "Build plan",
    buildMultiPatientPlan: "Build multi-{{patientTerm}} plan",
  },
  emptyState: {
    learnMore: "Learn more",
    multiPatient: {
      title: "No multi-{{patientTerm}} plans",
      body: "Save time and reach more of your {{patientTerm}} list with multi-{{patientTerm}} plans — shared directly in your {{patientTermPlural}}' accounts and can be sent through email or links.",
      searchBody: `It looks like there are no results for "{{ searchValue }}". Why not build something new?`,
    },
    templates: {
      title: "Create your first template",
      body: "Speed up your workflow with building blocks you can quickly apply to individual or multi-{{patientTerm}} plans.",
      searchBody: `It looks like there are no results for "{{ searchValue }}". Why not create something new?`,
    },
    searchTitle: "No results found",
  },
  planCard: {
    moreProducts: "+ {{ numRemainingProducts }} more",
    noProducts: "No products yet",
    patientsAccessSingle: "<0>{{ numSharedPatients }} {{ patientTerm }}</0> has access",
    patientsAccessPlural: "<0>{{ numSharedPatients }} {{ patientTermPlural }}</0> have access",
    allPatientsAccess: "<0>All {{ patientTermPlural }}</0> have access",
    staffAccessSingle: "<0>{{ numSharedPractitioners }} staff</0> has access",
    staffAccessPlural: "<0>{{ numSharedPractitioners }} staff</0> have access",
    allStaffAccess: "<0>All staff</0> have access",
    sharedWithYou: "Shared with you",
    onlyYou: "<0>Only you</0> have access",
  },
  drawer: {
    preview: "Preview",
    modifyAccess: "Modify access",
    durationDays: "{{duration}} days",
    evidence: "Evidence",
    saveAsTemplate: "Save as template",
    saveAsTemplateDescripion:
      "Save this plan as a template to apply to future plans and share with other staff.",
    templateName: "Template name",
    protocolDisclaimer:
      "<0>Disclaimer:</0> Protocols are intended solely as an informational reference tool for practicing health care professionals. The content provided is not intended to be for medical diagnosis or treatment, is not a substitute for your professional judgment, and is not meant to provide you medical or professional advice. You should evaluate and independently confirm the appropriateness of the content provided, including verifying uses, dosages, warnings and contraindications on product labels, and rely on your experience and judgment and other available resources when applying the provided content to an actual {{ patientTerm }} care situation. While content has been obtained from sources believed to be reliable, we cannot and do not guarantee the accuracy, validity, timeliness or completeness of the content. We make no representation or warranty, express or implied, including, without limitation, any warranty of merchantability or of fitness for a particular purpose, and you assume full responsibility for the use of the content and products, and agree that Fullscript and its content providers are not responsible or liable for any claim, loss, injury or damage arising from your use of the information. Statements regarding dietary and other health care supplements have not been evaluated by the FDA, and are not intended to diagnose, treat, cure, or prevent any disease.",
    confirmTemplateDelete: "Are you sure you want to delete this template?",
    confirmPlanDelete: "Are you sure you want to delete this plan?",
    templateCreatedSuccess: "Template created successfully!",
    tooltip: {
      disabedChange:
        "You can't change multi-{{patientTerm}} plans that another practitioner has created.",
    },
  },
  banner: {
    title: "Your protocols are now shareable plans",
    description:
      "We've automatically converted your protocols to multi-{{patientTerm}} plans and templates that you can access from this page.",
    learnMore: "Learn More",
    dismiss: "Dismiss",
  },
  planCreatedBanner: {
    title: "Plan created successfully",
    message: "You can modify access and manage this plan at any time.",
  },
  templateCreatedBanner: {
    title: "Template created successfully",
    message: "You can modify access and manage this template at any time.",
  },
  productsUnavailableMessage: {
    title: "{{count}} product is unavailable",
    title_plural: "{{count}} products are unavailable",
    message:
      "One or more plans contain products that are discontinued or out of stock. Select replacements or add substitutes to avoid {{patientTerm}} purchasing delays.",
    button: "View product substitutions",
  },
  productsDiscontinuedOrOOSMessage: {
    title: "Some products are unavailable",
    message: "Select replacements or add substitutes to avoid {{patientTerm}} purchasing delays.",
    button: "Update plan",
  },
} as const;
